import { Theme } from '@emotion/react';

const generateMainStyles = (theme:Theme) => ({
    articleClass: {
        '& table': {
            width: '100%',
            borderCollapse: 'separate',
            fontFamily: "'Arial', sans-serif",
            fontSize: '14px',
            marginTop: '20px',
            marginBottom: '20px',

            '& tbody': {
                position: 'relative',

                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    border: '1px solid #dde3ed',
                    borderRadius: '8px',
                    pointerEvents: 'none',
                },
            },

            '& th': {
                textAlign: 'left',
                padding: '6px',
                fontWeight: 600,
                fontSize: '14px',
                color: '#767676',
                backgroundColor: '#f9fafb',
                textTransform: 'uppercase',
            },

            '& td': {
                padding: '16px',
                fontSize: '14px',
                lineHeight: 1.6,
                color: theme.palette.common.black,
                borderBottom: '1px solid #e2e8f0',
                verticalAlign: 'top',
            },

            '& tr:nth-child(even)': {
                backgroundColor: '#f8fafc',
            },

            '& tr:hover': {
                backgroundColor: '#edf2f7',
            },
        },

        '& img': {
            marginTop: '20px',
            maxWidth: '100%',
        },

        '& strong': {
            fontWeight: 600,
        },

        '& h1': {
            fontSize: '24px',
            letterSpacing: '0.25px',
            fontWeight: 500,
            marginBottom: '24px',
        },

        '& h3': {
            marginBottom: '20px',
        },

        '& p': {
            marginBottom: '1em',
            marginTop: '1em',
            lineHeight: 1.625,
        },

        '& p, & li': {
            lineHeight: 1.625,
            fontFamily: theme.palette.common.font,
            fontSize: '16px',
            letterSpacing: '0.25px',
            fontWeight: 400,

            '&::marker': {
                color: theme.palette.common.bullet,
            },
        },

        '& li': {
            marginBottom: '4px',
            marginTop: '4px',
        },

        '& ol, & ul': {
            paddingInlineStart: '28px',
        },

        '& blockquote': {
            marginBlockStart: '0',
            marginBlockEnd: '0',
            marginInlineStart: '0',
            marginInlineEnd: '0',
            position: 'relative',
            borderRadius: '7px',
            background: theme.palette.primary.accentBlue,
            marginBottom: '20px',
            padding: '2px 2px 6px',

            '& > *': {
                padding: '40px 60px',
                background: theme.palette.common.white,
                borderRadius: '7px',
                margin: '0',
            },

            '&:after': {
                position: 'absolute',
                top: '20px',
                left: '20px',
                color: theme.palette.primary.accentBlue,
                width: '20px',
                fontFamily: "'britannic bold'",
                fontWeight: 500,
                height: '20px',
                fontSize: '15px',
                border: `1.5px solid ${theme.palette.primary.accentBlue}`,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                content: "'i'",
            },
        },

        '& hr + p': {
            display: 'none',
        },

        '& hr:has(+ p)': {
            display: 'none',
        },
    },
});

export default generateMainStyles;
